
import { useIsMobile } from "@/hooks/use-mobile";
import TLDRWidget from "./TLDRWidget";
import { TLDRAnalysis } from "@/hooks/useArticleAI";
import { motion } from "framer-motion";

interface AIWidgetsSidebarProps {
  tldrData: TLDRAnalysis | null;
  loadingTldr: boolean;
  selectedLanguage?: string;
}

const AIWidgetsSidebar = ({ tldrData, loadingTldr, selectedLanguage = 'en' }: AIWidgetsSidebarProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
      className="space-y-4"
    >
      <TLDRWidget
        data={tldrData}
        loading={loadingTldr}
        isRTL={selectedLanguage === 'ar'}
      />
    </motion.div>
  );
};

export default AIWidgetsSidebar;
